import firebase from 'firebase'
import 'firebase/performance'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTID,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPID,
  measurementId: process.env.VUE_APP_MEASUREMENTID,
  persistence: true
}
const app = firebase.initializeApp(firebaseConfig)
// export const perf = firebase.performance(app)
export default app



// WEBPACK FOOTER //
// ./src/plugins/firebase.js